import type { ModelCapabilities } from './types';

interface ModelCapabilityBadgeProps {
  capabilities?: ModelCapabilities;
  compact?: boolean;
}

const BADGES: Array<{ key: keyof ModelCapabilities; label: string; short: string; cls: string; title: string }> = [
  { key: 'tools',         label: 'Tools',     short: 'T',  cls: 'bg-sky-50 text-sky-700 border-sky-200',         title: 'Function/tool calling' },
  { key: 'strict_schema', label: 'Strict',    short: 'S',  cls: 'bg-indigo-50 text-indigo-700 border-indigo-200',title: 'Strict JSON schema enforcement' },
  { key: 'embedding',     label: 'Embed',     short: 'E',  cls: 'bg-emerald-50 text-emerald-700 border-emerald-200', title: 'Embedding model' },
  { key: 'rerank',        label: 'Rerank',    short: 'R',  cls: 'bg-teal-50 text-teal-700 border-teal-200',      title: 'Reranker model' },
  { key: 'vision',        label: 'Vision',    short: 'V',  cls: 'bg-violet-50 text-violet-700 border-violet-200',title: 'Multimodal vision input' },
  { key: 'realtime',      label: 'Realtime',  short: 'RT', cls: 'bg-amber-50 text-amber-700 border-amber-200',   title: 'Realtime/streaming voice API' },
];

export function ModelCapabilityBadge({ capabilities, compact }: ModelCapabilityBadgeProps) {
  if (!capabilities) return null;
  const active = BADGES.filter((b) => capabilities[b.key]);
  if (active.length === 0) return null;
  return (
    <span className="inline-flex items-center gap-1 flex-wrap">
      {active.map((b) => (
        <span
          key={b.key}
          title={b.title}
          className={`inline-flex items-center rounded border font-medium leading-tight ${b.cls} ${
            compact ? 'px-1 text-[9px]' : 'px-1.5 py-0.5 text-[10px]'
          }`}
        >
          {compact ? b.short : b.label}
        </span>
      ))}
    </span>
  );
}

export default ModelCapabilityBadge;
